(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fWbcT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf; }, function (v) { return $b9a4f744ab95abc4$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b9a4f744ab95abc4$export$f7ad0328861e2f03; }, function (v) { return $b9a4f744ab95abc4$export$f7ad0328861e2f03 = v; });
var $b9a4f744ab95abc4$export$6503ec6e8aabbaf;
var $b9a4f744ab95abc4$export$f7ad0328861e2f03;
"use strict";
var $b9a4f744ab95abc4$var$mapping = new Map();
function $b9a4f744ab95abc4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b9a4f744ab95abc4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b9a4f744ab95abc4$var$resolve(id) {
    var resolved = $b9a4f744ab95abc4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b9a4f744ab95abc4$export$6503ec6e8aabbaf = $b9a4f744ab95abc4$var$register;
$b9a4f744ab95abc4$export$f7ad0328861e2f03 = $b9a4f744ab95abc4$var$resolve;

});

parcelRegister("dOGL2", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a0f11cae5038e8ee$export$bdfd709ae4826697; }, function (v) { return $a0f11cae5038e8ee$export$bdfd709ae4826697 = v; });
var $a0f11cae5038e8ee$export$bdfd709ae4826697;
var $a0f11cae5038e8ee$export$c9e73fbda7da57b6;
var $a0f11cae5038e8ee$export$5a759dc7a1cfb72a;
"use strict";
var $a0f11cae5038e8ee$var$bundleURL = {};
function $a0f11cae5038e8ee$var$getBundleURLCached(id) {
    var value = $a0f11cae5038e8ee$var$bundleURL[id];
    if (!value) {
        value = $a0f11cae5038e8ee$var$getBundleURL();
        $a0f11cae5038e8ee$var$bundleURL[id] = value;
    }
    return value;
}
function $a0f11cae5038e8ee$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a0f11cae5038e8ee$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a0f11cae5038e8ee$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a0f11cae5038e8ee$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a0f11cae5038e8ee$export$bdfd709ae4826697 = $a0f11cae5038e8ee$var$getBundleURLCached;
$a0f11cae5038e8ee$export$c9e73fbda7da57b6 = $a0f11cae5038e8ee$var$getBaseURL;
$a0f11cae5038e8ee$export$5a759dc7a1cfb72a = $a0f11cae5038e8ee$var$getOrigin;

});

parcelRegister("rfO2h", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("hkgzJ")).then(function() {
    return parcelRequire("9uRDw");
});

});
parcelRegister("gZJRp", function(module, exports) {
"use strict";

var $bzWhm = parcelRequire("bzWhm");
module.exports = $bzWhm(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("bzWhm", function(module, exports) {
"use strict";
var $86e02b94fb59de77$var$cachedBundles = {};
var $86e02b94fb59de77$var$cachedPreloads = {};
var $86e02b94fb59de77$var$cachedPrefetches = {};
function $86e02b94fb59de77$var$getCache(type) {
    switch(type){
        case "preload":
            return $86e02b94fb59de77$var$cachedPreloads;
        case "prefetch":
            return $86e02b94fb59de77$var$cachedPrefetches;
        default:
            return $86e02b94fb59de77$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $86e02b94fb59de77$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments)["catch"](function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("cflly", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("CzZEj")).then(function() {
    return parcelRequire("9p1Ay");
});

});

parcelRegister("9Q5Bf", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("bltYJ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("gqt9i"))
]).then(function() {
    return parcelRequire("4UVGk");
});

});

parcelRegister("7Bxh7", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("k7LXQ")).then(function() {
    return parcelRequire("bHxXq");
});

});

parcelRegister("3rzIL", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("9hdDT")).then(function() {
    return parcelRequire("9daGP");
});

});

parcelRegister("75tpk", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("iubzo"))
]).then(function() {
    return parcelRequire("9xoUQ");
});

});

parcelRegister("2sdIT", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("bltYJ")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("etPnk"))
]).then(function() {
    return parcelRequire("5Eb5w");
});

});

parcelRegister("4pWhQ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("6d8Uk"))
]).then(function() {
    return parcelRequire("9Cfog");
});

});

parcelRegister("dwINV", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kcLCU")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("k674l"))
]).then(function() {
    return parcelRequire("bt3bc");
});

});

parcelRegister("5wHIp", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("02IkL")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("Hw6F8")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("kAUGT"))
]).then(function() {
    return parcelRequire("gKeZL");
});

});

parcelRegister("lRn9y", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("02IkL")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("Hw6F8")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("6ak0f"))
]).then(function() {
    return parcelRequire("ba0h9");
});

});

parcelRegister("2U0Kv", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("02IkL")),
    (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("e2sxN"))
]).then(function() {
    return parcelRequire("9T7Zl");
});

});

parcelRegister("9MkZ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.domReady = module.exports.ccmReady = void 0;
var $71e8dfd9d0b8fc28$var$domReady = module.exports.domReady = function domReady() {
    return new Promise(function(resolve) {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", resolve, {
            once: true
        });
        else resolve();
    });
};
var $71e8dfd9d0b8fc28$var$ccmReady = module.exports.ccmReady = function ccmReady() {
    return new Promise(function(resolve) {
        if (typeof CCM !== "undefined") resolve();
        else document.addEventListener("ccmReady", resolve, {
            once: true
        });
    });
};

});

parcelRegister("1h5Oh", function(module, exports) {


module.exports = (parcelRequire("gZJRp"))((parcelRequire("fWbcT")).resolve("f7LAB")).then(function() {
    return parcelRequire("iB8BA");
});

});

var $876aa3679130e71d$exports = {};


(parcelRequire("fWbcT")).register((parcelRequire("dOGL2")).getBundleURL("2iNWU"), JSON.parse('["2iNWU","as-legacy.js","hkgzJ","ccm19.9b997c70.js","CzZEj","ccmopen.b85662ab.js","gqt9i","collapse.befa7cd9.js","bltYJ","collapse.09cac51c.js","k7LXQ","eyeAble.a7a7f152.js","9hdDT","flyoutSearch.7f3e025b.js","iubzo","magnificPopup.6f809796.js","kcLCU","magnificPopup.b2cec138.js","etPnk","modal.7079afbe.js","6d8Uk","navHandler.6fbdc720.js","k674l","panel.8e7dd250.js","kAUGT","swiper.aee6de2a.js","Hw6F8","swiper.8144f37d.js","02IkL","swiper.5edd99d6.js","6ak0f","teaserSlider.ac0ec89d.js","e2sxN","videoModal.99d92e4f.js","f7LAB","powermailA11y.dd51ba4f.js"]'));

"use strict";

var $9MkZ6 = parcelRequire("9MkZ6");
function $765f16911476d698$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $765f16911476d698$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $765f16911476d698$var$_typeof(o);
}
function $765f16911476d698$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($765f16911476d698$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $765f16911476d698$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
} // =========================================================================
// Cache selectors for better performance
// =========================================================================
var $765f16911476d698$var$hasCCM = document.querySelectorAll("[data-ccm-loader-group]");
var $765f16911476d698$var$CCMopen = document.querySelector(".CCMopen");
var $765f16911476d698$var$collapse = document.querySelector(".collapse");
var $765f16911476d698$var$eyeAble = document.querySelector(".as-eyeable");
var $765f16911476d698$var$flyoutSearch = document.querySelector("#search");
var $765f16911476d698$var$lightbox = document.querySelector(".lightbox");
var $765f16911476d698$var$modal = document.querySelector(".modal");
var $765f16911476d698$var$navHandler = document.querySelector(".link-button") || document.querySelector(".icon-button");
var $765f16911476d698$var$panel = document.querySelector(".panel");
var $765f16911476d698$var$swiper = document.querySelector(".swiper-container");
var $765f16911476d698$var$teaserSlider = document.querySelector(".ctype-ce_isny_teaser_slider");
var $765f16911476d698$var$videoModal = document.querySelector(".video-modal");
var $765f16911476d698$var$powermailErrorHandler = document.querySelector(".ctype-powermail_pi1");













// =========================================================================
// Parallel imports
// =========================================================================
(0, $9MkZ6.domReady)().then(function() {
    var imports = [];
    if ($765f16911476d698$var$hasCCM) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("rfO2h"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$CCMopen) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("cflly"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$collapse) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("9Q5Bf"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$eyeAble) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("7Bxh7"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$flyoutSearch) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("3rzIL"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$lightbox) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("75tpk"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$modal) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("2sdIT"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$navHandler) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("4pWhQ"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$panel) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("dwINV"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$swiper) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("5wHIp"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$teaserSlider) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("lRn9y"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$videoModal) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("2U0Kv"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    if ($765f16911476d698$var$powermailErrorHandler) imports.push(Promise.resolve().then(function() {
        return (parcelRequire("1h5Oh"));
    }).then(function(res) {
        return $765f16911476d698$var$_interopRequireWildcard(res);
    }).then(function(m) {
        return m.init();
    }));
    // =========================================================================
    // Execute all in parallel
    // =========================================================================
    if (imports.length) Promise.all(imports)["catch"](console.error);
});

})();
//# sourceMappingURL=as-legacy.js.map
